// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { localCurrencySettings } from '../../../../utils/constans';

const NotEnoughFunds = ({ fundsInfo }) => (
  <div className="form_section">
    <div className="field_column with_spacing">
      <div className="field_value" style={{ textAlign: 'center' }}>
        {(fundsInfo.fundsNeededFromWallet - fundsInfo.holdFunds).toLocaleString(
          'en-US',
          localCurrencySettings,
        )}
        {' '}
        funds needed!
      </div>
    </div>
  </div>
);

export default NotEnoughFunds;
